import { Group, Image } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import logoSmallChat from '@/assets/logo-small-chat.svg';
import textSmallChat from '@/assets/text-small-chat.svg';

export function ProductLogo() {
    const { t } = useTranslation('prejoin');

    return (
        <Group
            gap="var(--spacing-2-5)"
            px="var(--spacing-4)"
            py="var(--spacing-2-5)"
            renderRoot={(props) => <Link {...props} to="/" />}
            wrap="nowrap"
        >
            {/* The mark is a background-inverse circle under a glyph; Figma swaps both colors in the dark scheme, and only invert flips two colors of one <img>. */}
            <Image
                alt=""
                h="var(--spacing-6)"
                src={logoSmallChat}
                style={{ flexShrink: 0, filter: 'invert(1)' }}
                w="var(--spacing-6)"
            />
            {/* The wordmark is drawn with currentColor, which is black inside <img>; the ui-kit filter token recolors it to the text color. */}
            <Image
                alt={t('productName')}
                src={textSmallChat}
                style={{ flexShrink: 0, filter: 'var(--color-foreground-foreground-filter)' }}
                w="auto"
            />
        </Group>
    );
}
